module.exports = __webpack_public_path__ + "static/media/marketing_art.169d6275.jpg";